<template>
  <div id="formulario">
    <form>
      <div class="row justify-content-center">
        <div class="form-group col-8 col-sm-6 col-md-6 col-lg-4">
          <label for="InputRun" class="center">Ingrese su RUN:</label>
          <input
            type="text"
            class="form-control"
            v-model.trim="run"
            aria-describedby="Run"
            placeholder="Ej: 1234567-8"
            v-on:keypress="onlyNumber"
          />
          <small>(Debe ingresar su RUN sin puntos y con guion)</small>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="form-group">
          <div class="g-recaptcha" :data-sitekey="rcapt_sig_key"></div>
        </div>
      </div>
      <div class="text-center">
        <button type="button" v-on:click="validar" class="btn btn-danger">
          Consultar
        </button>
      </div>
      <br />
      <!--     <div class="text-center">
        <a class="btn btn-info" href="https://www.procesoconstitucional.cl/" target="_blank" role="button">Revisa la Propuesta de Nueva Constitución Aquí</a>
      </div> -->
      <div class="container"></div>
    </form>
    <!-- <br /> -->
    <p class="text-center">{{ mensaje }}</p>
     <transition name="fade">
      <div class="row justify-content-center" v-if="statusCode == 200">
        <div class="col-lg-8">
          <div
            v-if="
              datos.estado_sufragio == 'SÍ' || datos.estado_sufragio == 'Sí (Persona Ausente por Desaparición Forzada)' || datos.estado_sufragio == 'NO'
            "
          >
            <table class="table table-striped">
              <tbody>
                <tr>
                  <td colspan="2">
                    <strong>DATOS ELECTORALES</strong>
                  </td>
                </tr>
                <tr>
                  <td style="width: 35%">RUN</td>
                  <td>{{ datos.cedula }}-{{ datos.dv }}</td>
                </tr>
                <tr>
                  <td>Nombre</td>
                  <td>{{ datos.nombre }}</td>
                </tr>
                <tr>
                  <td>Circunscripción</td>
                  <td>{{ datos.nombre_circuns }}</td>
                </tr>
<!--                 <tr v-if="datos.codigo_pais == 'CL'">
                  <td>Distrito</td>
                  <td>{{ datos.cod_pueblo }}</td>
                </tr> -->
                <!-- <tr v-if="datos.codigo_pais == 'CL'">
                  <td>Comuna</td>
                  <td>{{ datos.nombre_comuna }}</td>
                </tr>
                <tr v-else>
                  <td>Ciudad</td>
                  <td>{{ datos.nombre_comuna }}</td>
                </tr>
                <tr v-if="datos.codigo_pais == 'CL'">
                  <td>Provincia</td>
                  <td>{{ datos.nombre_provincia }}</td>
                </tr>
                <tr v-if="datos.codigo_pais == 'CL'">
                  <td>Región</td>
                  <td>{{ datos.nombre_region }}</td>
                </tr> -->
                <tr>
                  <td>País</td>
                  <td>{{ datos.glosa_pais }}</td>
                </tr>
                <!-- <tr v-if="true"> -->
                <tr v-if="false">
                  <td>Mesa</td>
                  <td>{{ datos.fusion }}{{ datos.tipomesa }}</td>
                </tr>
<!--                 <tr v-if="datos.codigo_pais == 'CL'">
                  <td>Habilitado para sufragar</td>
                  <td>
                    {{ datos.estado_sufragio }}
                    <b-link
                      href="https://consultainhabilitado.servel.cl/"
                      v-if="datos.estado_sufragio == 'NO'"
                      >(VER DETALLE INHABILIDAD)</b-link
                    >
                  </td>
                </tr>
                <tr v-else>
                  <td>Habilitado para sufragar</td>
                  <td>
                    No (Domicilio Electoral en el Extranjero)
                    <b-link
                      href="https://consultainhabilitado.servel.cl/"
                      v-if="datos.estado_sufragio == 'NO'"
                      >(VER DETALLE INHABILIDAD)</b-link
                    >
                  </td>
                </tr> -->
                <tr>
                  <td>Habilitado para sufragar</td>
                  <td>
                    {{ datos.estado_sufragio }}
                    <b-link
                      href="https://consultainhabilitado.servel.cl/"
                      v-if="datos.estado_sufragio == 'NO'"
                      >(VER DETALLE INHABILIDAD)</b-link
                    >
                  </td>
                </tr>
                <tr v-if="false">
                <!-- <tr v-if="true && datos.estado_sufragio == 'SÍ' && datos.codigo_pais == 'CL'"> -->
                  <!-- <tr v-if="true && datos.estado_sufragio == 'SÍ'"> -->
                  <td>Local de votación</td>
                  <td>{{ datos.nombre_local }}</td>
                </tr>
                <tr v-if="false">
                <!-- <tr v-if="true && datos.estado_sufragio == 'SÍ' && datos.codigo_pais == 'CL'"> -->
                  <!-- <tr v-if="true && datos.estado_sufragio == 'SÍ' "> -->
                  <td>Dirección del Local</td>
                  <td>{{ datos.direccion_local }}</td>
                </tr>
                <tr v-if="false">
                  <td>Mesa</td>
                  <td>{{ datos.fusion }}{{ datos.tipomesa }}</td>
                </tr>
              </tbody>
            </table>
            <!-- <table class="table table-striped" v-if="true"> -->
            <table class="table table-striped" v-if="false">
              <tbody>
                <tr>
                  <td colspan="2">
                    <strong>DESIGNACIONES</strong>
                  </td>
                </tr>
                <tr>
                  <td style="width: 35%">Vocal de mesa</td>
                  <td v-if="(datos.vocal == 'SÍ')">
                    <!-- {{ datos.vocal }} (En mesa {{ datos.mesa_fusion }})  <a type="button" class="btn btn-danger"  href="./CartillaMesa_Segunda_Votacion_GORE_2024.pdf" target="_self">Instrucción para vocales</a> -->
                    {{ datos.vocal }} (En mesa {{ datos.mesa_fusion }}) <a href="https://vocales.servel.cl/" target="_blank">Conoce tus funciones aqui</a> <br/> <small>El domingo 14 de diciembre, día de la elección, presentarse en su Local de Votación a las 7:30 horas.</small> 
                  </td>
                  <td v-else>{{ datos.vocal }}</td>
                </tr>
                <tr>
                  <td>Miembro Colegio Escrutador</td>
                  <td v-if="(datos.miembro == 'SÍ')">
                    {{ datos.miembro }} <br/> <small>El lunes 15 de diciembre, presentarse en el Colegio Escrutador designado a las 14:00 horas.</small> 
                  </td>
                  <td v-else>{{ datos.miembro }}</td>
                </tr>
                <tr v-if="datos.miembro == 'SÍ'">
                  <td>Colegio Escrutador</td>
                  <td>{{ datos.nombre_colegio }}</td>
                </tr>
                <tr v-if="datos.miembro == 'SÍ'">
                  <td>Ubicación</td>
                  <td>{{ datos.direccion_colegio }}</td>
                </tr>
  <!--               <tr>
                  <td>Pueblo indígena</td>
                  <td>{{ datos.cod_pueblo }}</td>
                </tr> -->
              </tbody>
            </table>
                <!-- Bloque de imágenes responsivas con condición -->
<!--                 <div class="row text-center mt-3">

                    <div class="col-12 col-md-4 mb-3" v-if="datos.fac_diptado">
                  <a href="../Facsimil PRESIDENTE SEGUNDA VOTACION 2025.pdf" target="_blank">
                    <img src="../assets/cedula_presidente2v.png" class="img-fluid rounded shadow-sm" alt="Imagen 3" />
                  </a>
                </div>
                </div> -->

              <!-- <a type="button" class="btn btn-danger btn-lg btn-block" :href="'https://consulta-candidato.servel.cl/?id='+datos.cedula+'-'+datos.dv" target="_blank">Revisa tus candidatos</a> -->
          </div>

          <div v-else>
            <table class="table table-striped">
              <tbody>
                <tr>
                  <td colspan="2">
                    <strong>DATOS ELECTORALES</strong>
                  </td>
                </tr>
                <tr>
                  <td>RUN</td>
                  <td>{{ datos.cedula }}-{{ datos.dv }}</td>
                </tr>
                <tr>
                  <td>Nombre</td>
                  <td>{{ datos.nombre }}</td>
                </tr>
           <tr>
                  <td>Habilitado para sufragar</td>
                  <td>
                    {{ datos.estado_sufragio }}
                    <b-link
                      href="https://consultainhabilitado.servel.cl/"
                      v-if="datos.estado_sufragio == 'NO'"
                      >(VER DETALLE INHABILIDAD)</b-link
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <a type="button" class="btn btn-danger btn-lg btn-block" href="https://www.procesoconstitucional.cl/wp-content/uploads/2023/11/Propuesta-Nueva-Constitucion.pdf" target="_blank">Revisa la propuesta de texto de nueva constitución 2023</a> -->
        
        </div>
        
      </div>
      <div class="row justify-content-center" v-else-if="statusCode == 201">
        <div class="alert alert-dark" role="alert">
          <strong>RUN no encontrado</strong>.
        </div>
      </div>
    </transition>

    <div class="text-center" v-if="spiner == true && statusCode == ''">
      <b-spinner label="Spinning"></b-spinner>
      <b-spinner type="grow" label="Spinning"></b-spinner>
      <b-spinner variant="danger" label="Spinning"></b-spinner>
      <b-spinner type="grow" label="Spinning"></b-spinner>
      <b-spinner label="Spinning"></b-spinner>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "formulario",
  data: function () {
    return {
      run: "",
      datos: [],
      datos2: [],
      spiner: false,
      mensaje: "",
      statusCode: "",
      api_url: process.env.VUE_APP_API_URL,
      rcapt_sig_key: process.env.VUE_APP_CAPTCHA_KEY,
      rcapt_id: 0,
    };
  },
  methods: {
    consultaDatos: function () {

      this.spiner = true;
      axios
        .post(this.api_url, {
          cedula: this.formatear(this.run),
          response: this.token,
        })
        .then((response) => {
          this.datos = response.data.datos;
          if (this.datos == null) {
            this.datos = this.jsonTemplate();
          }
          this.datos2 = response.data.datos2;
          if (this.datos2 == null) {
            this.datos2 = this.jsonTemplate();
          }
          this.statusCode = response.data.statusCode;
        })
        .catch((error) => console.log("error axios: ", error));
    },

    limpiar: function () {
      this.datos = [];
      this.datos2 = [];
      this.mensaje = "";
      this.spiner = false;
      this.statusCode = "";
      grecaptcha.enterprise.reset();
    },

    formatear: function (runnoformat) {
      var runformat = runnoformat;
      runformat = runformat.replace(".", "").replace(".", "");
      runformat = runformat.split("-");
      return runformat[0];
    },

     jsonTemplate: function () {
      var template = {
        cedula: "",
        dv: "",
        nombre: "",
        sexo: "",
        tipomesa: "",
        codigo_circuns: "",
        numero_mesa: "",
        fusion: "",
        mesa_fusion: "",
        estado_sufragio: "",
        nombre_circuns: "",
        nombre_comuna: "",
        nombre_provincia: "",
        numero_region: "",
        nombre_region: "",
        codigo_pais: "",
        glosa_pais: "",
        codigo_local: "",
        nombre_local: "",
        direccion_local: "",
        codigo_colegio: "",
        nombre_colegio: "",
        direccion_colegio: "",
        vocal: "",
        miembro: "",
      };
      return template;
    },

    // Valida el rut con su cadena completa "XXXXXXXX-X"
    validaRut: function (rutCompleto) {
      if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
      var tmp = rutCompleto.split("-");
      var digv = tmp[1];
      var rut = tmp[0];
      if (digv == "K") digv = "k";
      return this.dv(rut) == digv;
    },

    dv: function (T) {
      var M = 0,
        S = 1;
      for (; T; T = Math.floor(T / 10))
        S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
      return S ? S - 1 : "k";
    },

    onlyNumber: function ($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (
        (keyCode < 48 || keyCode > 57) &&
        keyCode !== 45 &&
        keyCode !== 75 &&
        keyCode !== 107
      ) {
        // 45 es guion, 75 es K y 107 es k
        $event.preventDefault();
      }
    },

    validar: function () {
      this.$ua.trackEvent("Consultar", "Click", "Ingresa Run");
      //if (!isNaN(this.formatear(this.run))) {
      if (this.validaRut(this.run)) {
        this.token = grecaptcha.enterprise.getResponse(this.rcapt_id);
        if (this.token.length != 0) {
          //Captcha Valido
          console.log(this.token);
          grecaptcha.enterprise.reset();
          this.limpiar();
          this.consultaDatos();
        } else {
          //Captcha Invalido
          this.limpiar();
          console.log("Token invalido");
          this.mensaje = "Debe contestar la validación de Captcha";
        }
      } else {
        this.limpiar();
        this.mensaje =
          "RUN inválido. Recuerda ingresar tu RUN completo, con dígito verificador después del guion.";
      }
    },
  },
};
</script>